import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

export const LoadingComponent: React.FC<LoadingProps> = ({
  message = "Loading...",
  fullScreen = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...(fullScreen && {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          zIndex: 9999,
        }),
        ...(!fullScreen && {
          width: "100%",
          height: "100%",
          minHeight: "200px",
        }),
      }}
    >
      <CircularProgress size={60} thickness={4}  sx={{
        color: "#BE1362"
      }}/>
      <Typography
        variant="h6"
        sx={{
          marginTop: 2,
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};
